import { message } from "antd";
import axios from "axios";
import { create } from "zustand";

export let useinventory = create((set, get) => ({
    products: [],
    ed: {},
    fetchProducts: async () => {
        try {
            const response = await axios.get('/products');
            set({ products: response.data });
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    },
    editCount: async (count) => {
        try {
            const response = await axios.put(`/products/${count.id}`, count);
            get().fetchProducts();
            message.success('Count updated successfully');
        } catch (error) {
            console.error('Error updating count:', error);
        }
    },
}))